import {
  createApp as _createApp,
  defineComponent,
  h,
  Suspense,
  type App,
  type Component,
} from 'vue'

export function createApp (component: Component): App {
  return _createApp(
    // wrapper w/ Suspense
    // (allows App to be an async. component)
    defineComponent(() => {
      return () => h(Suspense, {}, h(component))
    })
  )
}
